export const iconFontAwesomeSpinnersCompass = (
	<i className="fa-solid fa-compass"></i>
);
